import React, { Component } from 'react';

import ContentOuterBound from './common/atoms/ContentOuterBound';
import CallToAction from './common/molecules/CallToAction';
import ContentSpacer from './common/atoms/ContentSpacer';
import BodyText from './common/atoms/BodyText';
import Grid2CellUnevenSplit from './common/atoms/Grid2CellUnevenSplit';

import * as InternalPropTypes from '../constants/internal-types';
import * as Breakpoints from '../constants/breakpoints';
import {
  CallToActionTypeEnum,
  CallToActionWithAlignmentTypeEnum,
  TypeBackgroundColorTypes,
  TypeCallToActionTypes,
  TypeCallToActionWithAlignmentTypes,
  TypeSEOWeightTypes,
} from '../constants/cms-constants';
import SEOWeights from '../constants/cms/control-options/seo-weights';
import { getSEOWeight } from '../utils/SEOWeight';

const styles = {
  paddingBottom: '40px',
};

function getRender(type, header, link, ctaType, seoWeight) {
  const addSEOWeight = getSEOWeight(seoWeight, seoWeight);
  return (
    <div className={`cta-with-header-${type}`}>
      {header && (
        <BodyText
          className="body-text"
          type={BodyText.types.BOLD16}
          as={addSEOWeight}
        >
          {header}
        </BodyText>
      )}

      {link && <CallToAction link={link} type={ctaType} />}
    </div>
  );
}

type CallToActionWithHeaderProps = {
  header?: InternalPropTypes.RichText;
  link?: InternalPropTypes.Link;
  type?: TypeCallToActionWithAlignmentTypes;
  ctaType?: TypeCallToActionTypes;
  backgroundColor?: TypeBackgroundColorTypes;
  seoWeight?: TypeSEOWeightTypes;
};

class CallToActionWithHeader extends Component<CallToActionWithHeaderProps> {
  static ctaTypes = CallToAction.types;

  static types = CallToActionWithAlignmentTypeEnum;

  static defaultProps = {
    header: null,
    link: null,
    type: CallToActionWithAlignmentTypeEnum.LEFT,
    ctaType: CallToActionTypeEnum.REGULAR,
    backgroundColor: null,
    seoWeight: SEOWeights.P,
  };

  render() {
    const { header, link, type, ctaType, backgroundColor, seoWeight } =
      this.props;

    const addStyle = backgroundColor ? { background: backgroundColor } : {};
    // eslint-disable-next-line react/jsx-no-useless-fragment
    let result = <></>;
    if (type === CallToActionWithAlignmentTypeEnum.LEFT) {
      result = (
        <div className="call-to-action-with-header" css={[styles, addStyle]}>
          <ContentOuterBound>
            <ContentSpacer>
              <Grid2CellUnevenSplit
                leftCellCount={5}
                rightCellCount={5}
                onRenderCell1={() =>
                  getRender(type, header, link, ctaType, seoWeight)
                }
              />
            </ContentSpacer>
          </ContentOuterBound>
        </div>
      );
    }
    if (type === CallToActionWithAlignmentTypeEnum.RIGHT) {
      result = (
        <div className="call-to-action-with-header" css={[styles]}>
          <ContentOuterBound>
            <ContentSpacer>
              <Grid2CellUnevenSplit
                snapAtBreakpoint={Breakpoints.MobileDown}
                leftCellCount={4}
                rightCellCount={7}
                onRenderCell2={() =>
                  getRender(type, header, link, ctaType, seoWeight)
                }
              />
            </ContentSpacer>
          </ContentOuterBound>
        </div>
      );
    }

    return result;
  }
}

export default CallToActionWithHeader;
